import * as React from "react";
import type { SVGProps } from "react";
const SvgSend = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" className="sociavore-icon" viewBox="0 0 24 24" width="1em" height="1em" {...props}><path d="M22 2 11 13M22 2l-7 20-4-9-9-4z" /></svg>;
export default SvgSend;